var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-heading"},[(_vm.subHeading)?_c('h4',{staticClass:"is-size-6-desktop is-size-7-touch is-uppercase has-text-primary"},[_vm._v(_vm._s(_vm.subHeading))]):_vm._e(),(_vm.heading)?_c('h3',{staticClass:"is-size-5-desktop is-size-6-touch is-uppercase has-text-primary"},[_vm._v(_vm._s(_vm.heading))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }